import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { QueryParamsModel } from '../../../../core/_base/crud';
import { Template } from '../models';

export enum TemplateActionTypes {
  ToggleTemplatePageLoading = '[Template] Toggle Template Page Loading',
  ToggleTemplateActionLoading = '[Template] Toggle Template Action Loading',
  RequestTemplatePage = '[Template] Request Template Page',
  LoadTemplatePage = '[Template] Load Template Page',
  CancelTemplatePage = '[Template] Cancel Template Page',
  CreateTemplate = '[Template] Create Template',
  CreateTemplateOnServer = '[Template] Create Template On Server',
  UpdateTemplate = '[Template] Update Template',
  UpdateTemplateOnServer = '[Template] Update Template On Server',
  UpdateTemplateStatusOnServer = '[Template] Update Template Status On Server',
  ThrowTemplateError = '[Template] Throw Template Error',
  ClearTemplateError = '[Template] Clear Template Error',
}

export class ToggleTemplatePageLoading implements Action {
  readonly type = TemplateActionTypes.ToggleTemplatePageLoading;

  constructor(public payload: { pageLoading: boolean }) {}
}

export class ToggleTemplateActionLoading implements Action {
  readonly type = TemplateActionTypes.ToggleTemplateActionLoading;

  constructor(public payload: { actionLoading: boolean }) {}
}

export class RequestTemplatePage implements Action {
  readonly type = TemplateActionTypes.RequestTemplatePage;

  constructor(public payload: { query: QueryParamsModel }) {}
}

export class LoadTemplatePage implements Action {
  readonly type = TemplateActionTypes.LoadTemplatePage;

  constructor(
    public payload: { templates: Template[]; totalCount: number; query: QueryParamsModel },
  ) {}
}

export class CancelTemplatePage implements Action {
  readonly type = TemplateActionTypes.CancelTemplatePage;
}

export class CreateTemplate implements Action {
  readonly type = TemplateActionTypes.CreateTemplate;

  constructor(public payload: { template: Template }) {}
}

export class CreateTemplateOnServer implements Action {
  readonly type = TemplateActionTypes.CreateTemplateOnServer;

  constructor(public payload: { template: Template }) {}
}

export class UpdateTemplate implements Action {
  readonly type = TemplateActionTypes.UpdateTemplate;

  constructor(public payload: { template: Update<Template> }) {}
}

export class UpdateTemplateOnServer implements Action {
  readonly type = TemplateActionTypes.UpdateTemplateOnServer;

  constructor(public payload: { template: Template }) {}
}

export class UpdateTemplateStatusOnServer implements Action {
  readonly type = TemplateActionTypes.UpdateTemplateStatusOnServer;

  constructor(public payload: { template: Template }) {}
}

export class ThrowTemplateError implements Action {
  readonly type = TemplateActionTypes.ThrowTemplateError;

  constructor(public payload: { error: any }) {}
}

export class ClearTemplateError implements Action {
  readonly type = TemplateActionTypes.ClearTemplateError;
}

export type TemplateActions =
  | ToggleTemplatePageLoading
  | ToggleTemplateActionLoading
  | RequestTemplatePage
  | LoadTemplatePage
  | CancelTemplatePage
  | CreateTemplate
  | CreateTemplateOnServer
  | UpdateTemplate
  | UpdateTemplateOnServer
  | UpdateTemplateStatusOnServer
  | ThrowTemplateError
  | ClearTemplateError;
